export const EXPRESS_CHECKOUT_QUERY_PARAM = "express_checkout";
export const EXPRESS_CHECKOUT_INVOICE_ID_PARAM = "invoice_id";
export const EXPRESS_CHECKOUT_UUID1_PARAM = "uuid1";
export const EXPRESS_CHECKOUT_UUID2_PARAM = "uuid2";
